export enum ServiceTransactionType {
    Call = 0,
    Request = 1
}
